import { PageContent } from "./Types";
import { stringFields } from "./validation.mjs";
export function isPageContentFn(value: unknown): value is PageContent {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  const c = value as PageContent;
  return (
    stringFields.every((key) => typeof c[key] === "string") &&
    ["checkUsOut", "whatOurGuestsSay"].every((key) => {
      const s = (c as any)[key];
      return (
        s &&
        [
          "title",
          "content",
          "firstImg",
          "secondImg",
          "thirdImg",
          "firstAlt",
          "secondAlt",
          "thirdAlt",
        ].every((field) => typeof s[field] === "string") &&
        typeof s.visible === "boolean"
      );
    }) &&
    Array.isArray(c.categories) &&
    c.categories.every(
      (cat) =>
        cat &&
        typeof cat.id === "string" &&
        typeof cat.title === "string" &&
        typeof cat.visible === "boolean" &&
        Array.isArray(cat.items) &&
        cat.items.every(
          (item) =>
            item &&
            [
              "id",
              "title",
              "description",
              "subtitle",
              "img",
              "alt",
              "price",
              "link",
            ].every((key) => typeof (item as any)[key] === "string") &&
            typeof item.visible === "boolean" &&
            Array.isArray(item.includes) &&
            item.includes.every(
              (part) =>
                part &&
                typeof part.img === "string" &&
                typeof part.item === "string"
            )
        )
    ) &&
    Array.isArray(c.navigation) &&
    c.navigation.every(
      (link) =>
        link &&
        typeof link.id === "string" &&
        typeof link.title === "string" &&
        typeof link.href === "string" &&
        typeof link.visible === "boolean"
    ) &&
    typeof c.useMenuReferences === "boolean" &&
    ["featuredItemIds", "featuredDrinkIds"].every(
      (key) =>
        Array.isArray((c as any)[key]) &&
        (c as any)[key].every((id: unknown) => typeof id === "string")
    )
  );
}

export function publicContentFn(
  pageId: string,
  content: PageContent,
  menu?: PageContent | null
): PageContent & Record<string, unknown> {
  if (pageId === "menu")
    return {
      ...content,
      categories: content.categories
        .filter((category) => category.visible)
        .map((category) => ({
          ...category,
          items: category.items.filter((item) => item.visible),
        })),
    };
  if (pageId === "home" && menu && content.useMenuReferences) {
    const items = menu.categories
      .filter((c) => c.visible)
      .flatMap((c) => c.items)
      .filter((i) => i.visible);
    return {
      ...content,
      featured: [
        [
          {
            title: "Featured menu",
            items: content.featuredItemIds
              .map((id) => items.find((i) => i.id === id))
              .filter(Boolean),
          },
        ],
      ],
      featuredDrinks: [
        {
          title: "Featured drinks",
          items: content.featuredDrinkIds
            .map((id) => items.find((i) => i.id === id))
            .filter(Boolean),
        },
      ],
    };
  }
  return { ...content };
}
